import { Controller } from '@hotwired/stimulus'
import { toast } from '../../helpers/custom_events_helper'

export default class extends Controller {
  static values = {
    data: String,
    toast: Boolean
  }

  static targets = ["source"]

  async copy() {
    const text =
      (this.hasDataValue && this.dataValue) ||
      (this.hasSourceTarget && this.sourceTarget.innerText) || ""

    if (!text) return

    try {
      if (window.isSecureContext && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text)
      } else {
        this.legacyCopy(text)
      }

      if (this.toastValue) {
        setTimeout(() => {
          toast({ message: 'Copied to clipboard!', delay: 3000 })
        }, 50)
      }
    } catch (_) {
      this.legacyCopy(text)
    }

  }

  legacyCopy(text) {
    const ta = document.createElement("textarea")
    ta.value = text
    ta.setAttribute("readonly", "")
    ta.style.position = "fixed"
    ta.style.top = "-9999px"
    document.body.appendChild(ta)
    ta.select()
    document.execCommand("copy")
    document.body.removeChild(ta)
  }
}
